import { FLOATING_ELEMENT_PLACEMENT } from '../../../../../../constants/common'
import { useContentOverflow } from '../../../../../../hooks'
import { FloatingTooltip } from '../../../../../Floating'
import Text from '../../../../../Text'

import * as styles from './ApplicantProfileComplianceFact.module.css'

function ApplicantProfileComplianceFact({ label, value }) {
  const { overflow, setContentOverflowRef } = useContentOverflow()

  return (
    <>
      <Text isSecondary className={styles.factLabel}>
        {label}
      </Text>
      <FloatingTooltip
        content={value}
        disabled={!overflow}
        placement={FLOATING_ELEMENT_PLACEMENT.top}
      >
        <Text className={styles.factValue} ref={setContentOverflowRef}>
          {value}
        </Text>
      </FloatingTooltip>
    </>
  )
}

export default ApplicantProfileComplianceFact
